import { useState, useEffect, useRef, Fragment, memo, useMemo, useCallback } from "react";
import style from "./../index.module.scss";
import styleUi from "./OtherArea.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import IconButton from '@mui/material/IconButton';
import AppConfig from '../../AppConfig';
import { GoogleMap, DirectionsService, DirectionsRenderer, useJsApiLoader } from '@react-google-maps/api';
import { Portal } from "@mui/material";
import { fixWhiteLine, geocodeLatLng } from "../../comm/comm";
import * as YStyled from "../../Styleds";
import html2canvas from 'html2canvas';
import apiManager from '../../ApiManager';
import OverlayAlbum from "../../pages/Tab2/OverlayAlbum";
const OtherArea = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const [zoom, set_zoom] = useState(2);
    const pageRef = useRef();
    const [overlayAlbumArr, set_overlayAlbumArr] = useState([]);
    const albumPolyLineRef = useRef(null);
    const options = {
        disableDefaultUI: true, // 禁用所有默认的UI控件
        zoomControl: false, // 禁用缩放控件（如果disableDefaultUI不够）
        mapTypeControl: false, // 禁用地图类型控件（如果disableDefaultUI不够）
        scaleControl: false, // 禁用比例尺控件（如果disableDefaultUI不够）
        streetViewControl: false, // 禁用街景控件（如果disableDefaultUI不够）
        rotateControl: false, // 禁用旋转控件（如果disableDefaultUI不够）
        fullscreenControl: false, // 禁用全屏控件（如果disableDefaultUI不够）
        minZoom: 2, // 设置最大缩放级别
        maxZoom: 14,
        restriction: {
            latLngBounds: {
                north: 85,
                south: -85,
                east: 180,
                west: -180,
            },
            strictBounds: true,
        },
        styles: [
            {
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#212121"
                    }
                ]
            },
            {
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#212121"
                    }
                ]
            },
            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#757575"
                    }
                ]
            },
            {
                "featureType": "administrative.country",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "administrative.neighborhood",
                "elementType": "labels",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#9e9e9e"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#181818"
                    }
                ]
            },
            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#2c2c2c"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#8a8a8a"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#373737"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#3c3c3c"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#bcbcbc"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#292929"
                    }
                ]
            },
            {
                "featureType": "transit.station",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#616161"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                    {
                        "color": "#000000"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#3d3d3d"
                    }
                ]
            }
        ]

    };
    const [map, setMap] = useState(null);

    const onLoad = useCallback(map => {
        setMap(map);
        /* map.setCenter({
            lat: 23.6,
            lng: 121.029
        }); */
    }, []);

    const onUnmount = useCallback(map => {
        setMap(null);
    }, []);
    useEffect(() => {
        setInProp(true);
    }, [])

    useEffect(() => {
        if (!map) return;
        if(arg.myRewild.length===0) return;

        arg.myRewild.sort((a, b) => {
            if (a.achievement_released_star_unlocked_at > b.achievement_released_star_unlocked_at)
                return -1;
            else
                return 1;
        })
        let firstContry=null;
        const contryGroup = [];
        arg.myRewild.forEach(v => {
            if (!contryGroup[v.rewildingObj.rewilding_country_code]) {
                const countryObj = AppConfig.allCountry.find(c => c.code === v.rewildingObj.rewilding_country_code);
                if(!firstContry)
                    firstContry=countryObj;
                contryGroup[v.rewildingObj.rewilding_country_code] = { lat: countryObj.lat, lng: countryObj.lng, rewild: [] };
            }
            contryGroup[v.rewildingObj.rewilding_country_code].rewild.push(v);
        })
        console.log("firstContry",firstContry)
        if(firstContry)
        map.setCenter(firstContry);
        const serializedArray = Object.keys(contryGroup).map(key => ({
            countryCode: key,
            ...contryGroup[key]
        }));
        const FontScale = .3;
        const markers = serializedArray.map((location) => {
            const marker = new window.google.maps.Marker({
                position: location,
                label: null,
                icon: {
                    url: './map/icon_user_empty.png',
                    scaledSize: new window.google.maps.Size(32 * FontScale, 32 * FontScale), // 调整图标的大小
                    anchor: new window.google.maps.Point(16 * FontScale, 16 * FontScale),
                    labelOrigin: new window.google.maps.Point(16 * FontScale, 32 * FontScale)
                }
            });

            marker.addListener('click', (e) => {
                console.log(location)
                const geocoder = new window.google.maps.Geocoder();
                console.log("geocoder", geocoder);
                geocodeLatLng(geocoder, map, location, (country) => {
                    console.log(country)
                    addModalType({
                        cls: "ShareLog", arg: {
                            rewild: location.rewild,
                            bar: true,
                            closeBtn: true,
                            blocking: false,
                            dismiss: true,
                            name: country,
                            defaultOpenAlbumId: null,
                            closeCb: () => {
                                set_overlayAlbumArr([]);
                                if (albumPolyLineRef.current) {
                                    albumPolyLineRef.current.setMap(null);
                                    albumPolyLineRef.current = null;
                                }
                                
                                map.setZoom(2);
                            },
                            viewAlbumOnMap: (event) => {
                                viewAlbumOnMap(event);
                            }
                        }
                    })
                });

            });
            marker.setMap(map); // 将标记添加到地图上
            return marker;
        });

        // 清理函数：在组件卸载或 map 发生变化时移除标记
        return () => {
            markers.forEach(marker => marker.setMap(null));
        };
    }, [map]);

    function viewAlbumOnMap(event) {
        console.log("event", event);
        console.log("pageRef.current.clientHeight", pageRef.current.clientHeight)
        apiManager.fetchGet(`collaborative-log/${event.events_id}/polaroids`).then(__polaroids => {
            console.log("polaroids", __polaroids);
            const display_polaroids = [];
            __polaroids.forEach(polaroid => {
                if (!(polaroid.event_polaroids_lat === 0 && polaroid.event_polaroids_lng === 0))
                    display_polaroids.push(polaroid);
            });
            const uniqueCount = new Set(display_polaroids.map(item => `${item.event_polaroids_lat},${item.event_polaroids_lng}`)).size;
            set_overlayAlbumArr(display_polaroids);
            const bounds = new window.google.maps.LatLngBounds();
            display_polaroids.forEach(polaroid => {
                bounds.extend({ lat: polaroid.event_polaroids_lat, lng: polaroid.event_polaroids_lng });
            });
            // 計算新的南邊界 lat 高度  lng 寬度 左上到右下 p1 p2 p3 p4
            let y1 = bounds.getSouthWest().lat();
            let y2 = bounds.getNorthEast().lat();
            let x1 = bounds.getSouthWest().lng();
            let x2 = bounds.getNorthEast().lng();
            // 處理單一點情況
            if (uniqueCount === 1) {
                const singlePoint = display_polaroids[0];
                const buffer = 0.01; // 約等於 1 公里
                y1 = singlePoint.event_polaroids_lat - buffer * 2;
                y2 = singlePoint.event_polaroids_lat;
                x1 = singlePoint.event_polaroids_lng - buffer;
                x2 = singlePoint.event_polaroids_lng + buffer;
            }
            const dy = y2 - y1;
            let dx = x2 - x1;

            if (dy > dx) {
                const viewH = pageRef.current.clientHeight * .4;
                const pageW = pageRef.current.clientWidth;
                const viewP = pageW / viewH;
                const cx = (x1 + x2) / 2;
                x1 = cx - ((dy * viewP) / 2);
                x2 = cx + ((dy * viewP) / 2);
            }
            dx = x2 - x1;
            const pageH = pageRef.current.clientHeight;
            const pageW = pageRef.current.clientWidth;

            const R_screen = pageW / pageH;
            const R_div = dx / dy;

            // 假设画面的宽度W = 100
            const W = 100; // 100%

            // 计算画面的高度
            const H = W / R_screen;
            // 计算div的高度
            const H_div = W / R_div;
            // 计算偏移量
            const offset = (H - H_div) / 2;

            // 计算偏移百分比
            const offsetPercent = (offset / H_div);
            const offsetY = dy * (offsetPercent);
            y1 -= offsetY;
            y2 -= offsetY;
            // 創建新的 bounds
            const newBounds = new window.google.maps.LatLngBounds(
                new window.google.maps.LatLng(y1, x1),
                new window.google.maps.LatLng(y2, x2),
            );
            // 使用新的 bounds
            map.fitBounds(newBounds);
            if (albumPolyLineRef.current) {
                {
                    albumPolyLineRef.current.setMap(null);
                    albumPolyLineRef.current = null;
                }
            }

            albumPolyLineRef.current = new window.google.maps.Polyline({
                path: display_polaroids.map(polaroid => { return { lat: polaroid.event_polaroids_lat, lng: polaroid.event_polaroids_lng } }),
                geodesic: true,
                strokeColor: '#FFFFFF',
                strokeOpacity: 1,
                strokeWeight: 4
            });
            albumPolyLineRef.current.setMap(map);
        }).catch(err => {
            console.log(err);
        })

    }
    const dataUrlToBlob = async (dataUrl) => {
        const res = await fetch(dataUrl);
        return await res.blob();
    };
    const handleScreenshot = async () => {
        const canvas = await html2canvas(pageRef.current, {
            useCORS: true,
        });

        const context = canvas.getContext('2d');
        const imageData = fixWhiteLine(context, canvas);
        // 将修改后的图像数据放回 canvas
        context.putImageData(imageData, 0, 0);
        const dataUrl = canvas.toDataURL('image/jpeg', 1);
        const blob = await dataUrlToBlob(dataUrl);
        const imageBlobUrl = URL.createObjectURL(blob);

        addModalType({
            cls: "Capture",
            arg: {
                dataUrl: imageBlobUrl,
                blob: blob
            }
        });
    };
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "OtherArea"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <IconButton onClick={e => {
                                        setInProp(false)
                                    }}>
                                        <img src="./assets/ui/back_b.png" />
                                    </IconButton>
                                </div>
                                <div className={styleUi.view} ref={pageRef}>
                                    <GoogleMap
                                        mapContainerStyle={{
                                            width: "100%", height: "100%", outline: 'none', // 去除蓝框
                                            border: 'none'
                                        }}
                                        center={AppConfig.mapCenter}
                                        zoom={zoom}
                                        onLoad={onLoad}
                                        onUnmount={onUnmount}
                                        options={options}
                                        onClick={e => {

                                        }}
                                    >
                                        {overlayAlbumArr.map(polaroid => {
                                            return <OverlayAlbum key={v4()} polaroid={polaroid} map={map} addModalType={addModalType} />
                                        })}
                                    </GoogleMap>
                                </div>
                                <div className={styleUi.rightTool} >
                                    <YStyled.Col align="center">
                                        <YStyled.BTN_CIRCLE_1 w="3rem" h="3rem" borderRadiusStyle="top" onClick={e => {
                                            set_zoom(map.getZoom() + 1);
                                        }}><img src="./assets/ui/add_w.png" /></YStyled.BTN_CIRCLE_1>
                                        <YStyled.Row align="center" style={{ width: "3rem", background: "#7676803D" }}>
                                            <YStyled.Hr width="80%" color="#EBEBF599"></YStyled.Hr>
                                        </YStyled.Row>
                                        <YStyled.BTN_CIRCLE_1 w="3rem" h="3rem" borderRadiusStyle="bottom" onClick={e => {
                                            set_zoom(map.getZoom() - 1);
                                        }}><img src="./assets/ui/sub_w.png" /></YStyled.BTN_CIRCLE_1>
                                    </YStyled.Col>
                                    <YStyled.BTN_CIRCLE_1 w="3rem" h="3rem" onClick={e => {
                                        handleScreenshot()
                                    }}><img src="./assets/ui/capture.png" /></YStyled.BTN_CIRCLE_1>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(OtherArea);